import ModalDetail from "./Detail";
import {
    PRODUCT,
    DATATABLE_EXPORT,
    PRODUCT_LEVEL,
    PRODUCT_CATEGORY,
    USERS
} from "../../../../Config/ApiUrl";

export const Schema = {
    components: { ModalDetail },

    data() {
        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            detailModalActive: false,
            detailLoader: false,
            selectedUrl: this.ENDPOINT,
            tableId: "info-product-table",
            rowData: {},
            tableColumns: [
                {
                    title: 'Level',
                    type: "object",
                    key: "product_level",
                    modifier: (v) => {
                        return v ? v.product_level_code : "";
                    },
                },
                {
                    title: 'Category',
                    type: "object",
                    key: "product_category",
                    modifier: (v) => {
                        return v ? v.name : "";
                    },
                },
                {
                    title: this.$t("name"),
                    type: "text",
                    key: "name",
                },
                {
                    title: this.$t("description"),
                    type: "text",
                    key: "description",
                },
                {
                    title: this.$t("price"),
                    type: "custom-html",
                    key: "price",
                    modifier: (value) => {
                        return this.formattedIDR(value) ? this.formattedIDR(value) : this.formattedIDR(0);
                    },
                },
                {
                    title: this.$t("is_active"),
                    type: "custom-html",
                    key: "is_active",
                    isVisible: true,
                    modifier: (value) => {
                        let ClassName = "danger";

                        if (value === 1) ClassName = `success`;
                        else if (value === 0) ClassName = `warning`;

                        return `<span class="badge badge-sm badge-pill badge-${ClassName}">${
                            value ? "Active" : "Inactive"
                        }</span>`;
                    },
                },
            ],
            ENDPOINT: PRODUCT + "?product_category_exclude=3,2",
            actionObj: {
                title: this.$t("action"),
                type: "action",
            },
            options: {
                name: "InfoProduct",
                url: PRODUCT + "?product_category_exclude=3,2",
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: false,
                columns: [],
                actions: [
                    {
                        title: 'Detail',
                        icon: "eye",
                        type: "none",
                        component: "app-add-modal",
                        modalId: "detail-product",
                        modifier: () => this.$can('view_child_menu_info_product')
                    },
                ],
                filters: [
                    {
                        title: this.$t("is_active"),
                        type: "checkbox",
                        key: "is_active",
                        option: [
                            { id: true, value: "Active" },
                            { id: false, value: "Inactive" },
                        ],
                    },
                    {
                        title: "Product Level",
                        type: "search-and-select-filter",
                        key: "product_level_id",
                        settings: {
                            url: `/${PRODUCT_LEVEL}`,
                            modifire: (v) => {
                                return { id: v.product_level_id, name: v.product_level_code };
                            },
                            per_page: 10, 
                            queryName: "search",
                            loader: "app-pre-loader",
                            multiple: true,
                            params: {
                                is_active: true,
                            }, 
                        },
						listValueField: "name",
                        defaultValue: []
                    },
                    {
                        title: "Product Category",
                        type: "search-and-select-filter",
                        key: "product_category_id",
                        settings: {
                            url: `/${PRODUCT_CATEGORY}`,
                            modifire: (v) => {
                                return { id: v.id, name: v.category_code };
                            },
                            per_page: 10, 
                            queryName: "search",
                            loader: "app-pre-loader",
                            multiple: true,
                            params: {
                                is_active: true,
                            }, 
                        },
						listValueField: "name",
                        defaultValue: []
                    },
                    {
                        title: "Day",
                        type: "checkbox",
                        key: "day_id",
                        option: [
                            { id: 1, value: "Monday" },
                            { id: 2, value: "Tuesday" },
                            { id: 3, value: "Wednesday" },
                            { id: 4, value: "Thursday" },
                            { id: 5, value: "Friday" },
                            { id: 6, value: "Saturday" },
                            { id: 7, value: "Sunday" },
                        ],
                    },
                    {
                        title: "Teacher",
                        type: "search-and-select-filter",
                        key: "teacher_id",
                        settings: {
                            url: `/${USERS}`,
                            modifire: (v) => {
                                return { id: v.id, name: v.full_name };
                            },
                            per_page: 10, 
                            queryName: "search",
                            loader: "app-pre-loader",
                            multiple: true,
                            params: {
                                status_id_operator: 1,
                            }, 
                        },
						listValueField: "name",
                        defaultValue: []
                    },
                    {
                        title: "Packages",
                        type: "search-and-select-filter",
                        key: "package_name",
                        settings: {
                            url: `/master/list-packages/uniq`,
                            modifire: (v) => {
                                return { id: v.package_name, name: v.package_name };
                            },
                            per_page: 10, 
                            queryName: "search",
                            loader: "app-pre-loader",
                            multiple: true,
                        },
						listValueField: "name",
                        defaultValue: []
                    },


                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    methods: {
        
        reSetData() {
            this.rowData = {};
            this.selectedUrl = "";
        },
        formattedIDR(value) {
            // Format the value as IDR
            return new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
            }).format(value);
        },
    },
};
